import { Injectable, InjectionToken } from '@angular/core';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { JwtHelper } from 'angular2-jwt';

import { AuthProvider, RequestOptions } from './auth.provider';
import { User } from '~auth/model';
import { CommonService } from '../../util/common.service';

export const STORAGE: InjectionToken<Storage> = new InjectionToken<Storage>('AUTH_TOKEN_STORAGE');

@Injectable()
export abstract class TokenProvider implements AuthProvider {
  protected jwtHelper = new JwtHelper();

  constructor(protected storage: Storage, public tokenName: string, private service: CommonService) {
  }

  isAuthenticated() {
    try {
      const token = this.getToken();
      return token && !this.jwtHelper.isTokenExpired(token);
    } catch (e) {
      return false;
    }
  }

  abstract signIn(username: string, password: string);

  signOut(): Observable<boolean> {
    this.clearToken();
    return Observable.of(true);
  }

  abstract refresh(local?: boolean): Observable<User>;

  public getToken() {
    return this.storage.getItem(this.tokenName);
  }

  protected decodeToken(token: string) {
    return this.jwtHelper.decodeToken(token);
  }

  wrapRequest(options: RequestOptions): RequestOptions {
    if (!options) options = {};
    if (!options.headers) options.headers = new HttpHeaders();

    options.headers.append('Authorization', `Bearer ${this.getToken()}`);
    //options.headers.append('env', env);

    return options;
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    if (this.isAuthenticated()) {
      let env = this.service.getEnvironment();
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.getToken()}`,
          env:env
        }
      });
    }
    return request;
  }

  protected clearToken() {
    this.storage.removeItem(this.tokenName);
    this.storage.removeItem(this.tokenName + 'Profile');
    return this;
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/providers/token.provider.ts